import { getOptionHedgeValue } from './factories';

export const getOptionHedgePaymentDate = getOptionHedgeValue('paymentDate');
